/* Koriderm+ · galería, selector de ofertas, añadir al carrito y barra fija · v1.5 */
(function () {
  'use strict';
  // Varias secciones cargan este archivo: solo se inicializa una vez
  if (window.__kdInit) return; window.__kdInit = true;
  // import() indirecto: el empaquetador de Shopify convertiría un import() directo en require() y fallaría
  var dynImport = new Function('m', 'return import(m)');

  /* ---------- Galería ---------- */
  document.querySelectorAll('[data-kd-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('[data-slide]');
    var thumbs = g.querySelectorAll('[data-thumbs] [data-go]');
    var dots = g.querySelectorAll('[data-dots] [data-go]');
    var i = 0;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      var t = thumbs[i]; if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    g.querySelector('[data-prev]').addEventListener('click', function () { go(i - 1); });
    g.querySelector('[data-next]').addEventListener('click', function () { go(i + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.go); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.go); }); });
    // swipe en móvil
    var x0 = null, stage = g.querySelector('[data-stage]');
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
  });

  /* ---------- Ficha: ofertas + carrito ---------- */
  document.querySelectorAll('.kd-product').forEach(function (root) {
    var form = root.querySelector('form.kd-form');
    if (!form) return;
    var variant = root.dataset.variant;
    var qtyInput = form.querySelector('[data-qty-input]');
    var btn = form.querySelector('[data-atc]');
    var err = form.querySelector('[data-error]');
    var bundle = root.querySelector('[data-kd-bundle]');
    var sub = root.querySelector('[data-kd-sub] input');
    var sticky = document.querySelector('[data-kd-sticky]');

    function tier() {
      if (!bundle) return { qty: 1, variant: variant, gifts: [] };
      var sel = bundle.querySelector('input:checked');
      var t = sel ? sel.closest('[data-tier]') : bundle.querySelector('[data-tier]');
      // Cada oferta puede llevar su propia variante (packs con precio rebajado); si no, la del producto
      return { qty: +t.dataset.qty || 1, variant: t.dataset.variant || variant, gifts: (t.dataset.gifts || '').split(',').filter(Boolean) };
    }
    function paint() {
      if (!bundle) return;
      bundle.querySelectorAll('[data-tier]').forEach(function (t) { t.classList.toggle('is-selected', t.querySelector('input').checked); });
      qtyInput.value = tier().qty;
    }
    if (bundle) {
      if (!bundle.querySelector('input:checked')) bundle.querySelector('input').checked = true;
      bundle.addEventListener('change', paint); paint();
    }

    // Secciones del carrito que Horizon vuelve a renderizar tras añadir (cajón del carrito)
    function cartSectionIds() {
      return Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (c) { return c.dataset.sectionId; }).filter(Boolean).join(',');
    }
    function loadEvents() {
      // Horizon expone los eventos estándar de Shopify por import map; si no existen, seguimos sin ellos
      try { return dynImport('@shopify/events').catch(function () { return null; }); } catch (e) { return Promise.resolve(null); }
    }

    // El cajón vacío de Horizon no siempre se rellena con el evento: lo re-renderizamos con su propio renderer y lo abrimos
    function refreshDrawer(sections) {
      var ci = document.querySelector('cart-items-component');
      if (!ci || !ci.dataset.sectionId) return;
      var sid = ci.dataset.sectionId;
      // Se ejecuta después de los manejadores de Horizon (dos pasadas) para que el último estado sea el real
      function pass() {
        return dynImport('@theme/section-renderer').then(function (sr) {
          // Usamos el HTML que devuelve add.js (estado real del carrito); si no viene, lo pedimos al servidor
          if (sections && sections[sid]) return sr.morphSection(sid, sections[sid], { mode: 'hydration', injectStylesheet: true });
          return sr.sectionRenderer.renderSection(sid, { cache: false, mode: 'hydration', injectStylesheet: true });
        }).catch(function () {}).then(function () {
          var td = document.querySelector('cart-items-component');
          td = td && td.closest('theme-drawer');
          if (td && !td.isOpen && typeof td.open === 'function') td.open();
        });
      }
      setTimeout(pass, 400);
      setTimeout(pass, 1500);
    }

    function add() {
      var t = tier();
      var items = [{ id: +t.variant, quantity: t.qty, properties: t.gifts.length ? { 'Oferta': bundle.querySelector('input:checked').closest('[data-tier]').querySelector('.kd-tier__name').textContent.trim() } : undefined }];
      if (sub && sub.checked) items[0].selling_plan = +sub.value;
      t.gifts.forEach(function (id) { items.push({ id: +id, quantity: 1, properties: { 'Regalo': 'Gratis con tu compra' } }); });
      var itemCount = items.reduce(function (n, i) { return n + i.quantity; }, 0);
      btn.disabled = true; btn.classList.add('is-loading'); err.hidden = true;

      loadEvents().then(function (ev) {
        var deferred = ev && ev.CartLinesUpdateEvent ? ev.CartLinesUpdateEvent.createPromise() : null;
        if (deferred) {
          // Mismo evento que lanza el formulario nativo de Horizon: el cajón se refresca y se abre solo
          form.dispatchEvent(new ev.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }), promise: deferred.promise }));
        }
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items, sections: cartSectionIds() }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'No se pudo añadir'); return j; }); })
          .then(function (res) {
            return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
              if (deferred) {
                deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'product-form-component', sourceId: 'kd-product', itemCount: itemCount, productId: root.dataset.productId, sections: res.sections, didError: false } });
                refreshDrawer(res.sections);
              } else if (!document.querySelector('cart-drawer-component')) {
                window.location.href = '/cart';
              }
            });
          })
          .catch(function (e) { if (deferred) deferred.reject(e); err.textContent = e.message; err.hidden = false; });
      }).finally(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); add(); });

    /* ---------- Barra fija ---------- */
    if (sticky) {
      sticky.querySelector('[data-sticky-atc]').addEventListener('click', add);
      var io = new IntersectionObserver(function (en) { sticky.hidden = en[0].isIntersecting || en[0].boundingClientRect.top > 0; }, { threshold: 0 });
      io.observe(btn);
    }
  });

  /* ---------- Carrusel genérico (vídeos / testimonios) ---------- */
  document.querySelectorAll('[data-kd-carousel]').forEach(function (c) {
    var track = c.querySelector('[data-track]');
    var step = function () { var it = track.firstElementChild; return it ? it.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : 300; };
    var prev = c.querySelector('[data-prev]'), next = c.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    var dots = c.querySelectorAll('[data-dot]');
    if (dots.length) {
      var upd = function () { var i = Math.round(track.scrollLeft / step()); dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); }); };
      track.addEventListener('scroll', upd, { passive: true }); upd();
      dots.forEach(function (d, k) { d.addEventListener('click', function () { track.scrollTo({ left: k * step(), behavior: 'smooth' }); }); });
    }
  });

  /* ---------- Reseñas: orden (más recientes primero) y ver más ---------- */
  document.querySelectorAll('[data-kd-reviews]').forEach(function (r) {
    var grid = r.querySelector('.kd-rev__grid');
    if (grid) {
      var items = Array.prototype.slice.call(grid.querySelectorAll('.kd-review'));
      // Primero las que tienen foto; dentro de cada grupo, de más reciente a más antigua
      items.sort(function (a, b) {
        var pa = a.classList.contains('kd-review--photo') ? 1 : 0, pb = b.classList.contains('kd-review--photo') ? 1 : 0;
        if (pa !== pb) return pb - pa;
        return (b.getAttribute('data-date') || '').localeCompare(a.getAttribute('data-date') || '');
      });
      var initial = parseInt(r.getAttribute('data-initial'), 10) || 9;
      items.forEach(function (it, k) { it.hidden = k >= initial; grid.appendChild(it); });
    }
    var more = r.querySelector('[data-more]'); if (!more) return;
    more.addEventListener('click', function () {
      var hidden = r.querySelectorAll('.kd-review[hidden]');
      for (var k = 0; k < hidden.length && k < 7; k++) hidden[k].hidden = false;
      if (r.querySelectorAll('.kd-review[hidden]').length === 0) more.hidden = true;
    });
  });
})();
